import styled, { keyframes } from 'styled-components';

import Button from '../Button';
import { theme } from '../GlobalStyles';
import { Box } from '../Grid';

const SC = {};

const flexAlignCenter = `
display: flex;
align-items: center;
justify-content: center;
align-self: center;
`;

SC.PartnerWrapper = styled.div`
  ${flexAlignCenter};
  flex-direction: row;
  margin-bottom: 3rem;
  overflow: hidden;
  width: 100%;
  height: 100%;
  padding: 0;
  button:disabled {
    opacity: 0.5;
  }

  .slider.featured {
    ${(props) => props.count && 'padding-bottom: 3.75rem'};
  }

  .slider {
    ${flexAlignCenter};
    flex-direction: row;
    flex-wrap: wrap;
    transition: all 250ms linear;
    -ms-overflow-style: none; /* hide scrollbar in IE and Edge */
    scrollbar-width: none; /* hide scrollbar in Firefox */
    position: relative;
    .btn-slide,
    .btn-slide svg {
      width: 2.625rem;
      height: 2.625rem;
    }
    .btn-slide {
      position: absolute;
      bottom: 0;
      border-radius: 50%;
      background-color: #f0ebf2;
      cursor: pointer;
      border: none;
      display: block;
      text-align: center;
      padding: 0;

      &.prev {
        left: 36%;
        transform: rotate(180deg);
      }
      &.next {
        right: 36%;
      }
    }
    ${theme.mediaQueries.above.small} {
      .btn-slide,
      .btn-slide svg {
        width: 3rem;
        height: 3rem;
      }
    }
    ${theme.mediaQueries.above.xsmall} {
      &.all {
        justify-content: flex-start;
      }
    }
    ${theme.mediaQueries.above.xlarge} {
      padding-bottom: 1rem;

      .btn-slide {
        bottom: 40%;
        &.prev {
          left: -0.75rem;
        }
        &.next {
          right: -0.75rem;
        }
      }
    }
  }

  ${theme.mediaQueries.above.xlarge} {
    flex-direction: column;
    padding: 0;
    .slider.featured {
      flex-wrap: nowrap;
      margin: auto;
      max-width: 98%;
      padding-bottom: 0;
      .featured-card {
        img {
          max-width: 10.625rem;
        }
        width: 11rem;
        height: 11rem;
      }
    }
  }
`;

const fadeIn = keyframes`
  0% { opacity: 0.4; }
  100% { opacity: 1; }
`;

SC.PartnerCard = styled(Box)`
  padding: 0.75rem;
  animation: ${fadeIn} 1s;
  ${flexAlignCenter};
`;

SC.StyledCard = styled(Box)`
  background: #fff;
  position: relative;
  ${flexAlignCenter};
  flex-direction: column;
  box-shadow: 0 0 0.9375rem 0.1875rem rgba(0, 0, 0, 0.05);
  border-radius: 1.125rem;
  width: 9.125rem;
  height: 9.125rem;
  padding: 1.5rem;
  ${theme.mediaQueries.above.small} {
    width: 11.1875rem;
    height: 11.1875rem;
  }
`;

SC.StyledImageWrapper = styled.div`
  padding: 1rem;
`;

const pulse = keyframes`
  0% {
    opacity: 0.1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 0.1;
  }
`;

SC.Skeleton = styled.div`
  height: 0.5rem;
  width: 6rem;
  margin-bottom: 0.5rem;
  margin-left: 0.2rem;
  max-width: 100%;

  background-color: grey;
  animation-timing-function: ease-out;
  animation-iteration-count: infinite;
  animation-duration: 1.5s;
  animation-name: ${pulse};
  ${theme.mediaQueries.above.xlarge} {
    width: 8.75rem;
  }
`;

SC.LoadMore = styled(Button)`
  padding: 0.75rem 1.125rem;
  border-radius: 1.5rem;
  width: 100%;
  margin-bottom: 1.5rem;
  ${theme.mediaQueries.above.xlarge} {
    width: auto;
  }
`;

const partnerElements = {
  ...SC,
};

export default partnerElements;
